import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Row, Select, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';


import { addContractDetail, deleteContractDetail, getAllContractDetail, updateContractDetail } from '../../redux/rtk/features/contactDetail/contractDetailSlice';
import { getAllContractType } from '../../redux/rtk/features/masters/contractTypeSlice';
import { loadAllStaff } from '../../redux/rtk/features/user/userSlice';
import PageTitle from '../page-header/PageHeader';
dayjs.extend(utc);
dayjs.extend(timezone);


const ContractDetails = () => {
    const { Title } = Typography;
    const { Search } = Input;

    const [editingContractDetails, setEditingContractDetail] = useState(null);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.contractType);
    const [calculatedRate, setCalculatedRate] = useState(0);
    const users = useSelector((state) => state.users?.list);
    const contractDetail = useSelector((state) => state.contractDetail?.contractDetail);
    const [calculatedMonthlySalary, setCalculatedMonthlySalary] = useState(0);
    const [calculatedDailyHours, setCalculatedDailyHours] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const status = true;

    const handleFormValuesChange = (_, allValues) => {
        const annualSalary = allValues.annualSalary || 0;
        const workingHourPerDay = allValues.workingHourPerDay || 0;

        const monthlySalary = annualSalary / 12;

        const dailyHours = workingHourPerDay * 5;

        const annualWorkingHours = workingHourPerDay * 5 * 52;

        const ratePerHour = annualSalary / annualWorkingHours;

        setCalculatedMonthlySalary(monthlySalary.toFixed(2));
        setCalculatedDailyHours(dailyHours.toFixed(2));
        setCalculatedRate(ratePerHour.toFixed(2));
    };


    useEffect(() => {
        dispatch(getAllContractDetail());
        dispatch(loadAllStaff(status))
        dispatch(getAllContractType());
    }, []);

    // Filter data based on search text
    useEffect(() => {
        if (!contractDetail) {
            setFilteredData([]);
            return;
        }

        if (!searchText) {
            setFilteredData(contractDetail);
            return;
        }

        const filtered = contractDetail.filter(contract => {
            const userName = contract.user ? `${contract.user.firstName} ${contract.user.lastName}`.toLowerCase() : '';
            const annualSalary = contract.annualSalary ? contract.annualSalary.toString() : '';
            const workingHours = contract.workingHourPerDay ? contract.workingHourPerDay.toString() : '';
            const startDate = contract.startDate ? dayjs(contract.startDate).format("YYYY-MM-DD") : '';

            return userName.includes(searchText.toLowerCase()) ||
                   annualSalary.includes(searchText.toLowerCase()) ||
                   workingHours.includes(searchText.toLowerCase()) ||
                   startDate.includes(searchText.toLowerCase());
        });

        setFilteredData(filtered);
    }, [contractDetail, searchText]);

    const handleSearch = (value) => {
        setSearchText(value);
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            console.log("values", values);
            
            const formattedValues = {
                ...values,
                monthlySalary: calculatedMonthlySalary,
                workingHoursPerWeek: calculatedDailyHours,
                workingRatePerHour: calculatedRate,
                startDate: values.startDate ? values.startDate.format('YYYY-MM-DD') : null,
                endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
            };

            if (editingContractDetails) {
                const result = await dispatch(
                    updateContractDetail({
                        id: editingContractDetails.id,
                        values: formattedValues
                    })
                ).unwrap();

                if (result.message === 'success') {
                    message.success('Contract updated successfully');
                    dispatch(getAllContractDetail());
                } else {
                    message.error('Error updating contract!');
                }
            } else {
                const result = await dispatch(addContractDetail(formattedValues)).unwrap();
                if (result.message === 'success') {
                    dispatch(getAllContractDetail());
                } else {
                    message.error('Error adding Contract!');
                }
            }
            form.resetFields();
            setEditingContractDetail(null);
        } catch (error) {
            console.error('Error:', error);
            message.error('Failed to save contract: ' + error.message);
        }
    };


    // Handle deletion
    const handleDelete = async (id) => {
        try {
            const result = await dispatch(deleteContractDetail(id)).unwrap();
            if (result?.message === 'success') {
                dispatch(getAllContractDetail());
            } else {
                message.error('Error deleting contract!');
            }
        } catch (error) {
            console.error('Delete API error:', error);
        }
    };

    // Table columns
    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user',
            key: 'userName',
            // render: (user) => user?.userName || 'N/A',
            render: (user) => user ? `${user.firstName} ${user.lastName}` : 'N/A',

        },
        // {
        //     title: 'Contract Type',
        //     dataIndex: 'contractType',
        //     key: 'contractType',
        //     render: (contractType) => contractType?.contractType || 'N/A',
        // },
        {
            title: 'Annual Salary',
            dataIndex: 'annualSalary',
            key: 'annualSalary',
        },
        {
            title: 'Working Hours Per Day',
            dataIndex: 'workingHourPerDay',
            key: 'workingHourPerDay',
        },

        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            render: (startDate) => dayjs(startDate).format("YYYY-MM-DD"),
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            render: (endDate) => endDate?dayjs(endDate).format("YYYY-MM-DD"):"N/A",
        },

        // {
        //     title: 'Actions',
        //     key: 'actions',
        //     render: (_, record) => (
        //         <>
        //             <Button type="link" onClick={() => {
        //                 setEditingContractDetail(record);
        //                 form.setFieldsValue({
        //                     ...record,
        //                     startDate: record.startDate ? dayjs(record.startDate) : null,
        //                     endDate: record.endDate ? dayjs(record.endDate) : null
        //                 });
        //             }}>
        //                 Edit
        //             </Button>
        //             <Popconfirm
        //                 title="Are you sure you want to delete this contract?"
        //                 onConfirm={() => handleDelete(record.id)}
        //                 okText="Yes"
        //                 cancelText="No"
        //             >
        //                 <Button type="link" danger>
        //                     Delete
        //                 </Button>
        //             </Popconfirm>
        //         </>
        //     ),
        // },
    ];

    return (
        <div>
            <PageTitle title='Back' />
            <Row gutter={16}>
                <Col span={8}>
                    <Card title={editingContractDetails ? 'Edit Contract Details' : 'Add Contract Details'}>
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            name="ContractDetail-form"
                            labelCol={{ span: 14 }}
                            wrapperCol={{ span: 14 }}
                            onFinish={handleSubmit}
                            autoComplete="off"
                            onValuesChange={handleFormValuesChange}
                        >
                            <Form.Item
                                label="Name"
                                name="userId"
                                rules={[{ required: true, message: "Please select a user!" }]}
                            >
                                <Select placeholder="Select User" showSearch allowClear
                                    filterOption={(input, option) =>
                                        String(option.children).toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {users?.map((user) => (
                                        <Select.Option key={user.id} value={user.id}>
                                            {/* {user.userName} */}
                                            {`${user.firstName} ${user.lastName}`}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {/* <Form.Item
                                label="Contract Type"
                                name="contractTypeId"
                                rules={[{ required: true, message: "Please select a contract type!" }]}
                            >
                                <Select placeholder="Select Contract Type" showSearch allowClear
                                    filterOption={(input, option) =>
                                        String(option.children).toLowerCase().includes(input.toLowerCase())
                                    }>
                                    {list?.map((type) => (
                                        <Select.Option key={type.id} value={type.id}>
                                            {type.contractType}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item> */}


                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                label='Start Date'
                                name='startDate'
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input contact start date!",
                                    },
                                ]}
                            >
                                <DatePicker />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "20px" }}
                                label='End Date'
                                name='endDate'
                            >
                                <DatePicker />
                            </Form.Item>

                            <Form.Item
                                name="annualSalary"
                                label="Annual Salary"
                                rules={[{ required: true, message: 'Please enter rate per Hour!' }]}
                            >
                                <InputNumber placeholder="Enter rate per Hour" />
                            </Form.Item>

                            <Form.Item
                                name="workingHourPerDay"
                                label="Working Hours Per Day"
                                rules={[{ required: true, message: 'Please enter Working Hours Per Day!' }]}
                            >
                                <InputNumber placeholder="Enter Working Hours Per Day" />
                            </Form.Item>
                            <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                                <div className="text-lg font-medium">Calculated Values:</div>
                                <div className="text-blue-600">
                                    <p>Monthly Salary: £{calculatedMonthlySalary}</p>
                                    <p>Working Hours Per Week: {calculatedDailyHours}</p>
                                    <p>Rate Per Hour: £{calculatedRate}</p>
                                </div>
                            </div>

                            <Button type="primary" block htmlType="submit">
                                {editingContractDetails ? 'Update Contract Details' : 'Add Contract Details'}
                            </Button>
                        </Form>
                    </Card>
                </Col>
                <Col span={16}>
                    <Card 
                        title="Contract Details"
                        extra={
                            <Search
                                placeholder="Search by name, salary, hours, or date"
                                allowClear
                                onSearch={handleSearch}
                                onChange={(e) => handleSearch(e.target.value)}
                                style={{ width: 300 }}
                            />
                        }
                    >
                        <Table
                            dataSource={filteredData}
                            columns={columns}
                            rowKey="id"
                            loading={loading}
                            style={{ marginTop: 0 }}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ContractDetails;
